import * as _ from 'underscore'


//#region Public Types

export const DEPOSITORY_CONTENT_SERVICE_NAME = 'DepositoryContentService'
export const DEPOSITORY_CONTENT_SERVICE_PROVIDER_NAME = 'DepositoryContentServiceProvider'

//#endregion


export class DepositoryContentService {


    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Module.Depository.Content]' }

    //#endregion


    //#region Ctor

    constructor() { }

    //#endregion

}


export class DepositoryContentServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new DepositoryContentService();
    }]

    //#endregion
} 